import { IViewController } from "../../../../UserInterfaceModule/Models/IViewController";
import { ComponentService } from "../../../../UserInterfaceModule/Services/ComponentService";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { RefreshExpression } from "../../../Models/UserInterfaces/RefreshExpression";

export class RefreshExpressionEvaluator implements IExpressionEvaluator<RefreshExpression> {
  get type(): string {
    return "UserInterface.Refresh";
  }

  evaluate(expression: RefreshExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const componentService = context.GetProperty<ComponentService>(ComponentService.KEY);
    if (componentService) {
      const controller = componentService.getController<IViewController>(expression.TargetComponentId);
      if (controller) {
        return controller.refresh();
      }
    }
    return true;
  }
}
